/**
 * Created by chenguangpeng on 2018/10/09 17:02
 */
import Bridge from '../bridge'

const Caller_Common_Base_cmd = (data, callback) => {
    Bridge.WebViewJavascriptBridge.setup((JSBridge) => {
        JSBridge.callHandler('GTBridge_Common_Base_cmd', data, callback)
    })
}

const Caller_Common_Base_location = (callback) => {
    Bridge.WebViewJavascriptBridge.setup((JSBridge) => {
        JSBridge.callHandler('GTBridge_Common_Base_location','', callback)
    })
}
/* 获取app openToken */
const Caller_Common_Base_getOpenToken = (data, callback) => {
  Bridge.WebViewJavascriptBridge.setup((JSBridge) => {
    JSBridge.callHandler('GTBridge_Common_Base_getOpenToken', data, callback)
  })
}

/* 获取用户登录状态 */
const Caller_Common_Base_getLoginStatus = (data, callback) => {
  Bridge.WebViewJavascriptBridge.setup((JSBridge) => {
    JSBridge.callHandler('GTBridge_Common_Base_getLoginStatus', data, callback)
  })
}


export default {
    Caller_Common_Base_cmd,
    Caller_Common_Base_location,
    Caller_Common_Base_getOpenToken,
    Caller_Common_Base_getLoginStatus
}
